import { getCustomerByExternalReference, } from "../services/getCustomerByExternalReference.js";
import { getCustomerByIdentifier } from "../services/getCustomerByIdentifier.js";
import { createCustomer } from "../services/createCustomer.js";
import { updateCustomer } from "../services/updateCustomer.js";
import { mergeCustomerImportData } from "../utils/mergeCustomerImportData.js";
import Logger from "@cappelendamm/logger";
import { sanitizePhoneNumber } from "../utils/sanitize-phone-number.js";
import { getCustomerDataFactoryId } from "../selectors/getCustomerDatafactoryId.js";
import { CUSTOMER_EXTERNAL_REFERENCE_KEY } from "../constants.js";
/**
 * Create a new customer if it does not exist, or update existing customer with new import metadata if necessary.
 * @param customerInput Customer input
 * @param client Crystallize client
 */
export async function createCustomerIfNew(customerInput, { client }, idReference) {
    let customer;
    if (idReference) {
        Logger.log(`Looking up customer by identifier ${idReference} before creating new customer.`);
        const existing = await getCustomerByIdentifier({ customerIdentifier: idReference }, { client });
        if (existing?.identifier) {
            customer = existing;
        }
    }
    const datafactoryId = getCustomerDataFactoryId(customerInput);
    if (!customer && datafactoryId) {
        Logger.log(`Looking up customer by data factory id ${datafactoryId} before creating new customer.`);
        customer = await getCustomerByExternalReference({
            key: CUSTOMER_EXTERNAL_REFERENCE_KEY.DATA_FACTORY_ID,
            value: datafactoryId,
        }, { client });
    }
    const trimmedPhone = customerInput.phone?.trim();
    if (!customer && trimmedPhone) {
        Logger.log(`Looking up customer by phone before creating new customer.`);
        customer = await getCustomerByExternalReference({
            key: CUSTOMER_EXTERNAL_REFERENCE_KEY.PHONE,
            value: sanitizePhoneNumber(trimmedPhone),
        }, { client });
    }
    if (customer?.identifier) {
        Logger.log(`Customer with identifier ${customer.identifier} already exists. Skipping creation of new customer.`);
        // Try to merge new metadata and external references that don't already exist
        const updateData = mergeCustomerImportData(customer, customerInput);
        if (updateData) {
            Logger.log(`Updating customer ${customer.identifier} with new metadata and external references from import.`);
            await updateCustomer(updateData, customer.identifier, { client });
        }
        return customer.identifier;
    }
    return await createCustomer(customerInput, { client }, idReference);
}
